export const namespaces = {
  MPI: "MPI",
  COMMON: "COMMON",
  ERROR: "ERROR",
};
